"use client";

import { ShoppingCart } from "@/features/cart/ui";
import { useIsMobile, useScrollDirection } from "@/lib/shared/hooks";
import { Container, cn } from "@/ui";
import { DesktopNav } from "./DesktopNav";
import { MobileNav } from "./MobileNav";

/**
 * NavigationBar component - Main navigation container
 * Luxury styling: minimal border, refined backdrop blur, elegant transitions
 * Collapses to one line on scroll down, expands to two lines on scroll up
 */
export const NavigationBar = () => {
  const isMobile = useIsMobile();
  const isScrolledDown = useScrollDirection({ threshold: 10 });

  return (
    <header
      className={cn(
        "sticky top-0 z-50 w-full border-b border-border/20 bg-background/95 backdrop-blur-md supports-[backdrop-filter]:bg-background/70",
        "transition-all duration-300 ease-out",
        isScrolledDown && "shadow-sm",
      )}
    >
      <Container
        id="navbar"
        className={cn(
          "flex items-center relative",
          "transition-all duration-300 ease-out",
          isScrolledDown ? "py-2 md:py-3" : "py-4 md:py-5",
        )}
      >
        {isMobile ? <MobileNav /> : <DesktopNav isCollapsed={isScrolledDown} />}
        <ShoppingCart />
      </Container>
    </header>
  );
};
